import React, { useEffect, useState } from "react";
import {
  HStack,
  Stack,
  FormControl,
  FormLabel,
  Input,
  Button,
  Card,
  CardBody,
  CardFooter,
  Textarea,
  FormErrorMessage,
  // Checkbox,
} from "@chakra-ui/react";
import { Field } from "formik";
import { MdNavigateNext, MdNavigateBefore } from "react-icons/md";
import moment from "moment";
import { validateField } from "../../../../../utils/Validaciones";
import { CONSTANTS } from "../../../../../utils/dictionary";
import { lbsToTns } from "../../../../../utils/handleWeightConversion";

const CuartoPasoEtapa = (props) => {
  const {
    planificacion,
    setActiveStep,
    activeStep,
    values,
    handleChange,
    handleBlur,
    // handleSubmit,
    loading,
    user,
    touched,
    errors,
    setFieldValue,
    setSandcubesVaciar,
  } = props;

  const [autoelevador, setAutoelevador] = useState({ id: "", nombre: "" });
  const [sander, setSander] = useState({ id: "", nombre: "" });
  const [pozo, setPozo] = useState([]);
  const [isOpenConsumidoGranel, setIsOpenConsumidoGranel] = useState(false);
  const idTipoOperacion = Number(values.idTipoOperacion);

  const charCount = values.observacionesESC.length;
  const nextStep =
    idTipoOperacion != CONSTANTS.TIPO_OPERACION.A_GRANEL.ID
      ? activeStep - 1
      : activeStep - 2;

  const handleConsumidoSCAutoCalc = () => {
    if (idTipoOperacion === CONSTANTS.TIPO_OPERACION.A_GRANEL.ID) return 0;
    const cantidadSandCubesEtapa = values.sandcubesEtapa?.length || 0;
    // Si no existen sandCubes agrupados por malla, retornamos 0 ya que no se puede calcular el consumo
    if (cantidadSandCubesEtapa == 0) return 0;
    const sandCubesAgrupadosMallas = values.sandcubesEtapa.reduce(
      (acc, val) => {
        // Agrupamos los sandCubes por malla
        if (!val.malla) return acc; // Si no tiene malla, lo ignoramos
        // Si la malla ya existe, agregamos el sandCube a esa malla
        if (acc[val.malla]) {
          acc[val.malla].push(val);
        } else {
          // Si la malla no existe, creamos una nueva con el sandCube
          acc[val.malla] = [val];
        }
        return acc;
      },
      []
    );

    const mallasPlanificacion = planificacion.mallas;
    // Si no existen mallas en la planificación, retornamos 0 ya que no se puede calcular el consumo
    if (mallasPlanificacion?.length == 0) return 0;
    // Calculamos el consumo de SC por malla
    const consumidoSC = mallasPlanificacion?.reduce((acc, malla) => {
      // Si no existen sandCubes para esa malla, retornamos el acumulado
      if (!sandCubesAgrupadosMallas[malla.tipoMalla]) return acc;
      // Si existen sandCubes para esa malla, multiplicamos la cantidad de sandCubes por el tnsArenaSc de la malla
      // y sumamos el resultado al acumulado
      return (
        sandCubesAgrupadosMallas[malla.tipoMalla]?.length * malla.tnsArenaSc +
        acc
      );
    }, 0);
    return consumidoSC.toFixed(2);
  };

  const consumidoSCAutoCalc = handleConsumidoSCAutoCalc();

  const initialData = () => {
    // Controlar la apertura del input de consumidoGranel según el tipo de operación
    if (idTipoOperacion !== CONSTANTS.TIPO_OPERACION.SANDCUBES.ID) {
      setIsOpenConsumidoGranel(true);
    }

    // 1) A GRANEL -> consumidoSC SIEMPRE 0
    if (idTipoOperacion === CONSTANTS.TIPO_OPERACION.A_GRANEL.ID) {
      setFieldValue("consumidoSC", 0);
      setFieldValue("sandcubesEtapa", []);
      setSandcubesVaciar([]);
      return;
    }

    // 2) MIXTA o SANDCUBES -> calcular SC si no se está editando el campo manualmente
    if (idTipoOperacion !== CONSTANTS.TIPO_OPERACION.A_GRANEL.ID) {
      const calc = Number(handleConsumidoSCAutoCalc()); // ya devuelve 0 si no se puede
      setFieldValue("consumidoSC", isNaN(calc) ? 0 : calc);
    }

    // 3) SANDCUBES -> calcular SC y bloquear granel
    if (idTipoOperacion === CONSTANTS.TIPO_OPERACION.SANDCUBES.ID) {
      setFieldValue("consumidoGranel", 0);
      setIsOpenConsumidoGranel(false);
      return;
    }
  };

  const handleParse = () => {
    let a = values.idAutoE;
    let s = values.idSander;
    let p = values.idPozoEtapa;
    let x;
    let y;
    let z;

    z = planificacion.pozos.find((pozo) => pozo.nombrePozo === p);
    setPozo(z);

    if (
      planificacion.autoelevador1 &&
      parseInt(a) === planificacion.autoelevador1.idAutoE
    ) {
      x = planificacion.autoelevador1;
      setAutoelevador({ id: x.idAutoE, nombre: x.nombreAutoE });
    } else if (
      planificacion.autoelevador2 &&
      parseInt(a) === planificacion.autoelevador2.idAutoE
    ) {
      x = planificacion.autoelevador2;
      setAutoelevador({ id: x.idAutoE, nombre: x.nombreAutoE });
    }

    if (
      planificacion.sanderPrincipal &&
      parseInt(s) === planificacion.sanderPrincipal.idSander
    ) {
      y = planificacion.sanderPrincipal;

      setSander({ id: y.idSander, nombre: y.codigoSander });
    } else if (
      planificacion.sanderBackup &&
      parseInt(s) === planificacion.sanderBackup.idSander
    ) {
      y = planificacion.sanderBackup;
      setSander({ id: y.idSander, nombre: y.codigoSander });
    }
  };

  useEffect(() => {
    initialData();
    handleParse();
  }, [idTipoOperacion, consumidoSCAutoCalc]);

  const calculateConsumidoTotal = () => {
    const consumidoSC =
      idTipoOperacion === CONSTANTS.TIPO_OPERACION.SANDCUBES.ID
        ? parseFloat(consumidoSCAutoCalc)
        : 0;
    const consumidoGranelLbs = parseFloat(values.consumidoGranel) || 0;
    const consumidoGranel = lbsToTns(consumidoGranelLbs);
    const consumidoTotal = parseFloat(
      (consumidoSC + consumidoGranel).toFixed(2)
    );
    return consumidoTotal;
  };

  useEffect(() => {
    setFieldValue && setFieldValue("consumidoTotal", calculateConsumidoTotal());
  }, [values.consumidoSC, values.consumidoGranel]);

  // Función para limitar a 2 decimales
  const handleDecimalChange = (e) => {
    const { value } = e.target;
    // Permite solo números y hasta dos decimales
    if (/^\d*\.?\d{0,2}$/.test(value) || value === "") {
      handleChange(e);
    }
  };

  return (
    <Stack w="100%" pb={2}>
      <HStack justifyContent="space-around" pb={3}>
        <FormControl w="2xs">
          <FormLabel fontWeight="semibold">ID Pozo</FormLabel>
          <Input value={pozo?.nombrePozo} bg="brand.gris_medio" readOnly />
        </FormControl>
        <FormControl w="2xs">
          <FormLabel fontWeight="semibold">Nro. Etapa (pozo)</FormLabel>
          <Input
            w="2xs"
            value={values.limpieza ? 0 : values.numPozoEtapaSC}
            bg="brand.gris_medio"
            readOnly
          />
        </FormControl>
        <FormControl w="2xs">
          <FormLabel fontWeight="semibold">Nro. Etapa (total)</FormLabel>
          <Input
            w="2xs"
            value={values.limpieza ? 0 : values.numTotalEtapaSC}
            bg="brand.gris_medio"
            readOnly
          />
        </FormControl>
      </HStack>
      <HStack justifyContent="space-around" pb={3}>
        <FormControl w="2xs">
          <FormLabel fontWeight="semibold">Fecha y Hora de Inicio</FormLabel>
          <Input
            w="2xs"
            value={moment(values.fechaInicioEtapaSC).format("DD/MM/YYYY HH:mm")}
            bg="brand.gris_medio"
            readOnly
          />
        </FormControl>
        <FormControl w="2xs">
          <FormLabel fontWeight="semibold">Fecha y Hora de Final</FormLabel>
          <Input
            w="2xs"
            type={"datetime-local"}
            name="fechaFinalEtapaSC"
            value={values.fechaFinalEtapaSC}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </FormControl>

        <FormControl w="2xs">
          {planificacion.dosificadora && (
            <>
              <FormLabel fontWeight="semibold">Wetsand</FormLabel>
              <Input
                value={values.etapaWeTSanD === true ? "si" : "no"}
                textTransform="uppercase"
                bg="brand.gris_medio"
                readOnly
              />
            </>
          )}
        </FormControl>
      </HStack>
      <HStack justifyContent="space-around" pb={3}>
        <FormControl w="2xs">
          <FormLabel fontWeight="semibold">Supervisor</FormLabel>
          <Input
            w="2xs"
            value={values.supervisor}
            bg="brand.gris_medio"
            readOnly
          />
        </FormControl>
        <FormControl w="2xs">
          <FormLabel fontWeight="semibold">Operador</FormLabel>
          <Input
            w="2xs"
            value={values.operador1}
            bg="brand.gris_medio"
            readOnly
          />
        </FormControl>
        <FormControl w="2xs">
          <FormLabel fontWeight="semibold">Operador</FormLabel>
          <Input
            w="2xs"
            value={values.operador2}
            bg="brand.gris_medio"
            readOnly
          />
        </FormControl>
      </HStack>
      <HStack justifyContent="space-around" pb={3}>
        <Field
          name="consumidoSC"
          validate={(value) =>
            validateField("decimal", value, "Consumido en SandCubes")
          }
        >
          {({ field }) => (
            <HStack w="2xs">
              <FormControl
                isRequired={
                  idTipoOperacion != CONSTANTS.TIPO_OPERACION.A_GRANEL.ID
                }
                isInvalid={errors.consumidoSC && touched.consumidoSC}
              >
                <FormLabel fontWeight="semibold">
                  Tns. Consumido en SandCubes
                </FormLabel>
                <Input
                  {...field}
                  type="number"
                  step="0.01"
                  name="consumidoSC"
                  value={
                    idTipoOperacion === CONSTANTS.TIPO_OPERACION.A_GRANEL.ID
                      ? 0.0
                      : values.consumidoSC
                  }
                  onChange={handleDecimalChange}
                  onBlur={handleBlur}
                  bg={"brand.gris_medio"}
                  readOnly
                />
                <FormErrorMessage>{errors.consumidoSC}</FormErrorMessage>
              </FormControl>
              {/* <Checkbox
                alignSelf={"flex-start"}
                paddingTop={12}
                borderColor="blackAlpha.500"
                isChecked={isOpenConsumidoSC}
                onChange={() => {
                  // Reset the value when checkbox is unchecked
                  if (isOpenConsumidoSC) {
                    setFieldValue &&
                      setFieldValue("consumidoSC", consumidoSCAutoCalc);
                    // values.consumidoSC = consumidoSCInicial;
                  } else {
                    setFieldValue &&
                      setFieldValue("consumidoSC", consumidoSCInicial);
                  }
                  setIsOpenConsumidoSC(!isOpenConsumidoSC);
                }}
                colorScheme={"orange"}
                fontSize={"16px"}
                size={"md"}
                disabled={
                  idTipoOperacion == CONSTANTS.TIPO_OPERACION.A_GRANEL.ID
                }
              /> */}
            </HStack>
          )}
        </Field>
        <Field
          name="consumidoGranel"
          validate={(value) =>
            validateField("decimal", value, "Consumido en Granel")
          }
        >
          {({ field }) => (
            <HStack w="2xs">
              <FormControl
                isRequired={
                  idTipoOperacion != CONSTANTS.TIPO_OPERACION.SANDCUBES.ID
                }
                isInvalid={errors.consumidoGranel && touched.consumidoGranel}
              >
                <FormLabel fontWeight="semibold">
                  Lbs. Consumido en Granel
                </FormLabel>
                <Input
                  {...field}
                  type="number"
                  step="0.01"
                  name="consumidoGranel"
                  value={
                    idTipoOperacion !== CONSTANTS.TIPO_OPERACION.SANDCUBES.ID
                      ? values.consumidoGranel
                      : 0.0
                  }
                  onChange={handleDecimalChange}
                  onBlur={handleBlur}
                  onFocus={(e) => {
                    e.target.value = e.target.value.replace(/,/g, ".");
                  }}
                  bg={isOpenConsumidoGranel ? "white" : "brand.gris_medio"}
                  readOnly={
                    idTipoOperacion == CONSTANTS.TIPO_OPERACION.SANDCUBES.ID
                  }
                />
                <FormErrorMessage>{errors.consumidoGranel}</FormErrorMessage>
              </FormControl>
              {/* <Checkbox
                alignSelf={"flex-start"}
                paddingTop={12}
                borderColor="blackAlpha.500"
                isChecked={isOpenConsumidoGranel}
                onChange={() => {
                  // Reset the value when checkbox is unchecked
                  if (!isOpenConsumidoGranel) {
                    values.consumidoGranel = consumidoGranelInicial;
                  }
                  setIsOpenConsumidoGranel(!isOpenConsumidoGranel);
                }}
                colorScheme={"orange"}
                fontSize={"16px"}
                size={"md"}
                disabled={
                  idTipoOperacion ==
                  CONSTANTS.TIPO_OPERACION.SANDCUBES.ID
                }
              /> */}
            </HStack>
          )}
        </Field>
        <FormControl w="2xs">
          <FormLabel fontWeight="semibold">Tns. Consumido Total</FormLabel>
          <Input
            w="2xs"
            type="text"
            // step="0.01"
            value={values.consumidoTotal?.toFixed(2).replace(".", ",")}
            bg="brand.gris_medio"
            readOnly
          />
        </FormControl>
      </HStack>
      <HStack justifyContent="space-around" pb={1}>
        <FormControl w="2xs">
          <FormLabel fontWeight="semibold">Maquinista</FormLabel>
          <Input
            w="2xs"
            value={values.maquinista}
            bg="brand.gris_medio"
            readOnly
          />
        </FormControl>
        <FormControl w="2xs">
          <FormLabel fontWeight="semibold">Sander</FormLabel>
          <Input w="2xs" value={sander.nombre} bg="brand.gris_medio" readOnly />
        </FormControl>
        <FormControl w="2xs">
          <FormLabel fontWeight="semibold">Autoelevador</FormLabel>
          <Input
            w="2xs"
            value={autoelevador.nombre}
            bg="brand.gris_medio"
            readOnly
          />
        </FormControl>
      </HStack>

      <HStack w="100%" px={5}>
        <Button
          fontSize={12}
          fontWeight="semibold"
          color="brand.naranja"
          border="1px solid #FF8200"
          variant="outline"
          leftIcon={<MdNavigateBefore fontSize="20px" />}
          _hover={{ bg: "brand.naranja", color: "white" }}
          onClick={() => setActiveStep(nextStep - 1)}
        >
          Atras
        </Button>
        <Stack placeSelf={"center"} w={"100%"}>
          <Field
            name="observacionesESC"
            validate={(value) =>
              validateField("textArea", value, "Observaciones")
            }
            w={"100%"}
          >
            {({ field }) => (
              <FormControl
                isInvalid={
                  errors?.observacionesESC && touched?.observacionesESC
                }
              >
                <FormErrorMessage>{errors?.observacionesESC}</FormErrorMessage>
                <Card variant="unstyled" bg="#fff">
                  <CardBody>
                    <Textarea
                      {...field}
                      placeholder="Descripción"
                      border="1px solid #FF8200"
                      name="observacionesESC"
                      onChange={handleChange} // Reemplazamos con la nueva función
                      value={values.observacionesESC}
                      maxLength="250"
                      resize="none"
                    />
                  </CardBody>
                  <CardFooter placeSelf="end" color="#fff" pr={2} m={"unset"}>
                    {charCount}/250
                  </CardFooter>
                </Card>
              </FormControl>
            )}
          </Field>
        </Stack>
        <Button
          fontSize={12}
          fontWeight="semibold"
          bg="brand.naranja"
          color="white"
          rightIcon={<MdNavigateNext fontSize="20px" />}
          variant="solid"
          form="FormularioEtapa"
          _hover={{ bg: "white", color: "brand.naranja" }}
          type="submit"
          isDisabled={loading || user.idRol === "usuarioIT"}
        >
          Finalizar etapa
        </Button>
      </HStack>
    </Stack>
  );
};

export default CuartoPasoEtapa;
